import axios from "axios"
import library from "../../../utils/Library"

export const getInfoARCA = async (CUIT) => {
  const TOKEN = sessionStorage.getItem("token")
  const URL = library.getBaseAPIUrl("afip_api") + "/getPerson"
  try {
    const dataCUIT = await axios.post(
      URL,

      {
        cuit: CUIT,
      },
      {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      },
    )
    const result = dataCUIT?.data?.contribuyente ?? null
    return result
  } catch (error) {
    console.log(error)
    return null
  }
}
